
import { Controller } from "@hotwired/stimulus"
import throttle from "lodash/throttle"
import { createFragment } from "../lib/helpers"
import { urlEncodeFormData } from "../lib/csrf_fetch"

const fetchAndReplace = (url, formData, element) => {
  // This used to pass the fields as a `body` on a GET. mrujs quietly folded
  // that body into the query string and dropped it from the request; native
  // fetch throws ("Request with GET/HEAD method cannot have body"), so build
  // the query string ourselves.
  const query = urlEncodeFormData(formData)
  const separator = url.includes("?") ? "&" : "?"

  fetch(`${url}${separator}${query}`, { method: "GET" })
    .then(resp => resp.text())
    .then(html => {
      const fragment = createFragment(html)
      const fragmentRoot = fragment.querySelector("[data-controller*='remotely-update']")

      element.outerHTML = fragmentRoot.outerHTML
    })
}

const throttledFetchAndReplace = throttle(fetchAndReplace, 250, { trailing: false })

export default class extends Controller {
  static targets = ["field"]
  static values = {
    url: String
  }

  connect() {
    this._element = this.element
  }

  now(_event) {
    let formData = new FormData()

    this.fieldTargets.forEach(field => {
      let value = field.value

      if (field.type == "checkbox") {
        value = field.checked
      }

      formData.append(field.name, value)
    })

    throttledFetchAndReplace(this.urlValue, formData, this.element)
  }
}